import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/silenceLogs";
import App from "@/App";

// PWA: register service worker (required for install prompt on Chrome/Edge)
if ("serviceWorker" in navigator) {
  const registerSW = () => navigator.serviceWorker.register("/sw.js").catch(() => {});
  if (document.readyState === "complete") {
    registerSW();
  } else {
    window.addEventListener("load", registerSW);
  }
}

// PWA: capture the install prompt globally so /instalar can use it even if
// the event fired before that page mounted (SPA navigation)
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  window.dispatchEvent(new Event("pwa:installable"));
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
